import { apiRequest } from './client';

/**
 * FEAT-014 — the caller's own notifications.
 *
 * There is no function here that names a recipient, because there is no
 * endpoint that accepts one. Every call acts on the signed-in user.
 */

export type NotificationLinkView = 'support' | 'bookings' | 'visitors' | 'employees';

export interface Notification {
  id: string;
  type: string;
  /** Rendered server-side, in the caller's language. */
  message: string;
  link_view: NotificationLinkView | null;
  link_type: string | null;
  link_id: string | null;
  occurred_at: string;
  read_at: string | null;
}

export interface Inbox {
  items: Notification[];
  unread: number;
  /** REQ-119 — per navigation entry. Absent keys mean zero. */
  badges: Partial<Record<NotificationLinkView, number>>;
}

export function getNotifications(): Promise<Inbox> {
  return apiRequest<Inbox>('/notifications');
}

/** Omitting the id marks every notification read (REQ-079). */
export function markNotificationRead(id?: string): Promise<Inbox> {
  return apiRequest<Inbox>('/notifications/read', { method: 'POST', body: id ? { id } : {} });
}

export function markViewRead(view: NotificationLinkView): Promise<Inbox> {
  return apiRequest<Inbox>('/notifications/read-view', { method: 'POST', body: { view } });
}
